module.exports = __webpack_public_path__ + "static/media/ErrorX.ee980ce5.svg";